// /src/store/networkManagment/types.ts

import { DetailledIpAddressInformations } from '../../dataTypes/networkManagment/types';

export const FETCH_ALL_IPS_DETAILS_REQUEST = 'FETCH_ALL_IPS_DETAILS_REQUEST';
export const FETCH_ALL_IPS_DETAILS_SUCCESS = 'FETCH_ALL_IPS_DETAILS_SUCCESS';
export const FETCH_ALL_IPS_DETAILS_FAILURE = 'FETCH_ALL_IPS_DETAILS_FAILURE';

export const FETCH_ONE_IP_DETAILS_REQUEST = 'FETCH_ONE_IP_DETAILS_REQUEST';
export const FETCH_ONE_IP_DETAILS_SUCCESS = 'FETCH_ONE_IP_DETAILS_SUCCESS';
export const FETCH_ONE_IP_DETAILS_FAILURE = 'FETCH_ONE_IP_DETAILS_FAILURE';

export interface NetworkState {
  loading            : boolean;
  ipDetails          : Map<string, DetailledIpAddressInformations>;
  error              : string | null;
  lastFetchTimestamp : number;
}

export const initialState: NetworkState = {
  loading            : false,
  ipDetails          : new Map(),
  error              : null,
  lastFetchTimestamp : 0,
};

export interface FetchAllIpsDetailsRequestAction {
  type: typeof FETCH_ALL_IPS_DETAILS_REQUEST;
}

export interface FetchAllIpsDetailsSuccessAction {
  type: typeof FETCH_ALL_IPS_DETAILS_SUCCESS;
  payload: DetailledIpAddressInformations[];
}

export interface FetchAllIpsDetailsFailureAction {
  type: typeof FETCH_ALL_IPS_DETAILS_FAILURE;
  payload: string;
}

export interface FetchOneIpDetailsRequestAction {
  type: typeof FETCH_ONE_IP_DETAILS_REQUEST;
}

export interface FetchOneIpDetailsSuccessAction {
  type: typeof FETCH_ONE_IP_DETAILS_SUCCESS;
  payload: DetailledIpAddressInformations;
}

export interface FetchOneIpDetailsFailureAction {
  type: typeof FETCH_ONE_IP_DETAILS_FAILURE;
  payload: string;
}

export type NetworkActionTypes =
  | FetchAllIpsDetailsRequestAction
  | FetchAllIpsDetailsSuccessAction
  | FetchAllIpsDetailsFailureAction
  | FetchOneIpDetailsRequestAction
  | FetchOneIpDetailsSuccessAction
  | FetchOneIpDetailsFailureAction;
